module.exports = __webpack_public_path__ + "img/5eaad0f.jpg";